<script lang="ts" setup>
import type { PropType } from 'vue';
import RothcoCta from '@/components/RothcoCta.vue';
import useLiveChat from '@/helpers/composables/useLiveChat';
interface ContactUsTile {
    title: string;
    details: string[];
    isLiveChat: boolean;
}
let props = defineProps({
    tiles: {
        type: Array as PropType<ContactUsTile[]>,
        required: true
    }
})

const { openLiveChat } = useLiveChat();
</script>
<template>
    <div class="contact_us-tiles">
        <div v-for="(tile, index) of tiles" class="contact_us-tile bg-rothcoCream" :key="index">
            <div class="contact_us-tile--title title-l">{{ tile.title }}</div>
            <p v-for="(detail, detailIndex) of tile.details" class="contact_us-tile--details paragraph-details" v-html="detail.text" :key="`detail-${detailIndex}`" />
            <RothcoCta
                v-if="tile.isLiveChat"
                ctaType="button"
                button_icon="carret"
                class="contact_us-tile--button primary" @click="openLiveChat({sessionStarted: true})">
                Chat Now
            </RothcoCta>
        </div>
    </div>
</template>